import React, { useState } from 'react';
import './App.css';
import { Route, Routes, Router, BrowserRouter } from 'react-router-dom';
import Home from './Home'
import Problems from './Problems';
import Profile from './Profile';
import Login from './Login';
import Algorithms from './Algorithms';
import Ds from './Ds';
import OOP from './OOP';
import String from './String';
import Puzzles from './Puzzles';
import Reverse from './Algorithms/Reverse';
import SumOfTwo from './Algorithms/SumOfTwo';
import Palindrome from './Algorithms/Palindrome';
import FizzBuzz from './Algorithms/FizzBuzz';
import Counting from './Algorithms/Counting';
import LongCommSub from './Algorithms/LongCommSub';
import MergeIntervals from './Algorithms/MergeIntervals';
import BinaryTreeMax from './Algorithms/BinaryTreeMax';
import Sudoku from './Algorithms/Sudoku';
import ShortPathBg from './Algorithms/ShortPathBg';
import LLPalindrome from './Data Structures/LLPalindrome';
import StackMin from './Data Structures/StackMin';
import QueueStacks from './Data Structures/QueueStacks';
import BST from './Data Structures/BST';
import MaxDepth from './Data Structures/MaxDepth';
import Trie from './Data Structures/Trie';
import SDBT from './Data Structures/SDBT';
import HeapSort from './Data Structures/HeapSort';
import RBT from './Data Structures/RBT';
import Bplus from './Data Structures/Bplus';
import ReverseString from './String Manipulation/ReverseString';
import StringPal from './String Manipulation/StringPal';
import VowCons from './String Manipulation/VowCons';
import Remove from './String Manipulation/Remove';
import Compression from './String Manipulation/Compression';
import LongSub from './String Manipulation/LongSub';
import Anagram from './String Manipulation/Anagrams';
import ZigZagConv from './String Manipulation/ZigZagConv';
import REMatch from './String Manipulation/REMatch';
import MinWindow from './String Manipulation/MinWindow';
import Bank from './OOP/Bank';
import Rectangle from './OOP/Rectangle';
import Student from './OOP/Student';
import Calculator from './OOP/Calculator';
import Email from './OOP/Email';
import Library from './OOP/Library';
import Employee from './OOP/Employee';
import Shape from './OOP/Shape';
import Shopping from './OOP/Shopping';
import Inventory from './OOP/Inventory';
import WordSearch from './Puzzles/WordSearch';
import Crossword from './Puzzles/Crossword';
import { Analytics } from '@vercel/analytics/react';

function App() {
  return (
    <BrowserRouter>
      <Analytics />
      <Routes>
        <Route path='/' element={<Home />}/>
        <Route path='/problems' element={<Problems />}/>
        <Route path='/profile' element={<Profile />}/>
        <Route path='/login' element={<Login />}/>
        <Route path='/problems/algorithms' element={<Algorithms />}/>
        <Route path='/problems/ds' element={<Ds />}/>
        <Route path='/problems/string' element={<String />}/>
        <Route path='/problems/oop' element={<OOP />}/>
        <Route path='/problems/puzzles' element={<Puzzles />}/>
        <Route path='/problems/reverse-a-string' element={<Reverse />}/>
        <Route path='/problems/sum-of-two' element={<SumOfTwo />}/>
        <Route path='/problems/palindrome' element={<Palindrome />}/>
        <Route path='/problems/fizzbuzz' element={<FizzBuzz />}/>
        <Route path='/problems/counting' element={<Counting />}/>
        <Route path='/problems/long-comm-sub' element={<LongCommSub />}/>
        <Route path='/problems/merge-intervals' element={<MergeIntervals />}/>
        <Route path='/problems/bt-max' element={<BinaryTreeMax />}/>
        <Route path='/problems/sudoku' element={<Sudoku />}/>
        <Route path='/problems/short-path-dg' element={<ShortPathBg />}/>
        <Route path='/problems/ll-palindrome' element={<LLPalindrome />}/>
        <Route path='/problems/stack-min-emt' element={<StackMin />}/>
        <Route path='/problems/queue-stacks' element={<QueueStacks />}/>
        <Route path='/problems/bst-valid' element={<BST />}/>
        <Route path='/problems/max-dep-bt' element={<MaxDepth />}/>
        <Route path='/problems/trie-imt' element={<Trie />}/>
        <Route path='/problems/sd-bt' element={<SDBT />}/>
        <Route path='/problems/heap-sort' element={<HeapSort />}/>
        <Route path='/problems/red-black-tree' element={<RBT />}/>
        <Route path='/problems/b+tree' element={<Bplus />}/>
        <Route path='/problems/reverse-words-string' element={<ReverseString />}/>
        <Route path='/problems/string-palindrome' element={<StringPal />}/>
        <Route path='/problems/vowels-consonants' element={<VowCons />}/>
        <Route path='/problems/rmv-duplicates' element={<Remove />}/>
        <Route path='/problems/string-compression' element={<Compression />}/>
        <Route path='/problems/longest-substring' element={<LongSub />}/>
        <Route path='/problems/grp-anagrams' element={<Anagram />}/>
        <Route path='/problems/zigzag-conv' element={<ZigZagConv />}/>
        <Route path='/problems/re-matching' element={<REMatch />}/>
        <Route path='/problems/min-window-substring' element={<MinWindow />}/>
        <Route path='/problems/bank-account' element={<Bank />}/>
        <Route path='/problems/rectangle' element={<Rectangle />}/>
        <Route path='/problems/student' element={<Student />}/>
        <Route path='/problems/calculator' element={<Calculator />}/>
        <Route path='/problems/email' element={<Email />}/>
        <Route path='/problems/library' element={<Library />}/>
        <Route path='/problems/employee-department' element={<Employee />}/>
        <Route path='/problems/shape-hierarchy' element={<Shape />}/>
        <Route path='/problems/online-shopping' element={<Shopping />}/>
        <Route path='/problems/inventory-mgmt' element={<Inventory />}/>
        <Route path='/problems/word-search' element={<WordSearch />}/>
        <Route path='/problems/crossword' element={<Crossword />}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
